<template>
    <div :class="computedClass">
        <div class="f-regular f-14 f-c-midgrey m-d-4">{{ title }}</div>
        <div class="d-flex overflow-auto" style="gap: 12px">
            <img
                v-for="(image, index) in showImages"
                :key="index"
                class="img-view"
                :src="image.src"
                alt=""
                @click="openMedia(image)"
            >
        </div>
        <SOImagePreview
            ref="imagePreview"
			:modalId="imgId"
        />
    </div>
</template>

<script>
import SOImagePreview from "./SOImagePreview";
export default {
    name: "SOImageList",
    components: {
        SOImagePreview,
    },
    props: {
        title: {
            type: String,
            default: "Dokumentasi Transaksi",
        },
        images: {
            type: Array,
            default: () => [],
            required: true
        },
        class: {
            type: String,
            default: "",
        },
    },
	data: () => ({
		showImages: [],
		imgId: null
	}),
    methods: {
        openMedia(media) {
			const src = media.type.includes('video') ? media.videoUrl : media.src
			this.imgId = media.id
			setTimeout(() => {
				this.$refs.imagePreview.open(src, media.type);
			}, 100);
        },
		initImages() {
			if (!this.images.length) {
				return;
			}
			this.showImages = this.images.map((image) => {
				const baseUrl = 'https://storage.googleapis.com/' + image.cloud_bucket + '/'
				let imgUrl = baseUrl + (image.cloud_thumb || image.cloud_name)
				const videoUrl = image.type.includes('video') ? `${baseUrl}${image.cloud_name}` : null
				return {
					...image,
					src: imgUrl,
					videoUrl: videoUrl,
				}
			})
			this.showImages.forEach(async (image, index) => {
				let imgUrl = 'https://storage.googleapis.com/' + image.cloud_bucket + '/' + (image.cloud_thumb || image.cloud_name)
				if (imgUrl.includes('.heic') || imgUrl.includes('.HEIC')) {
					this.heicToJpg(imgUrl).then((res) => {
						this.showImages[index].src = res
					})
				} 
			});
		}
    },
    computed: {
        computedClass() {
            return this.class;
        },
    },
	mounted() {
		this.initImages();
	}
}
</script>

<style scoped>
.img-view {
    min-width: 80px;
    min-height: 80px;
    width: 80px;
    height: 80px;
    border: 1px solid #E1E5EC;
    box-sizing: border-box;
    border-radius: 3px;
    object-fit: cover;
}
</style>